import { useApi, identityApiRef } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { systemPrototypeApiRef } from '@agilelab/plugin-wb-system-prototype-common';

export const useDeleteSystemPrototype = () => {
  const systemPrototypeApi = useApi(systemPrototypeApiRef);
  const alertApi = useApi(customAlertApiRef);
  const identityApi = useApi(identityApiRef);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: string) => {
      const credentials = await identityApi.getCredentials();
      const options = { token: credentials.token };
      return systemPrototypeApi.deleteSystemPrototype(name, options);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['system-prototypes'],
      });
      alertApi.post({
        severity: 'success',
        message: 'Prototype deleted successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
